import "./scss/newsletter-agro.scss"

import { Form } from "../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../types/widget.props"
import { Device } from "@/utils/device"

export function WidgetAgro({ configuracaoSite, device, textosPersonalizados }: Readonly<WidgetProps>) {
    const isTabletMobile = (device === Device.APP || device === Device.MOBILE || device === Device.TABLET)
    const hasAllFields = (configuracaoSite.newsletterExibeNome || configuracaoSite.newsletterExibeTelefone)
    
    return (
        <div className="container">
            <div className="widget-cadastro-news news-agro">
                <div className="news-area">
                    <span className="title">{textosPersonalizados.newsletterTitle}</span>
                    <span className="sub-title">{textosPersonalizados.newsletterDescription}</span>

                    <Form
                        configuracaoSite={configuracaoSite}
                        textosPersonalizados={textosPersonalizados}
                        dinformname="newsletter-widget-agro"
                        hasFieldTelefone
                        className={{
                            form: `flex ${isTabletMobile && hasAllFields ? ' all-fields' : ''}`,
                            button: "button button-medium button-base"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default class WidgetAgroApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetAgro {...props} />)
    }
}